import EA from '../helpers/init';

export default EA.Methods.videoLazyLoad = ($this) => {
    const videoEl = $this;

    function createObserver() {
        let observer;

        let options = {
            root: null,
            rootMargin: '200px',
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(videoEl);
    }

    function handleIntersect(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                videoEl.play();
            } else {
                videoEl.pause();
            }
        });
    }

    createObserver();
};
